$(document).ready(function(){
  $('.classic-t-shirt-blanket .product_form .swatch_options .swatch_opt_0 .option_label .span_lable_as li').click(function(){
    var dvalue2= $(this).data('value');
    var dvalue1 = dvalue2.replace(/\s+/g, '-');
    var tolowe = dvalue1.toLowerCase();
    $( ".classic-t-shirt-blanket .swatch_opt_0 #custom_0 option").each(function(index,value) {
var current_v = $(this).val();
      var current2 = current_v.replace(/\s+/g, '-');
      var curtolower = current2.toLowerCase();
      if (curtolower.indexOf(tolowe) > -1) {
        setTimeout(function(){
       $('.classic-t-shirt-blanket #custom_0').val(current_v).trigger('change');
       }, 100);   
      }
    });
  });

// color

   $('.classic-t-shirt-blanket .product_form .swatch_options .swatch_opt_2 .option_label .swatch_group').click(function(){
     
    var name_color= $(this).find('.name_color').html();
    var name_color2 = name_color.toLowerCase();
    $( ".swatch_opt_2 #custom_2 option").each(function(index,value) {
var current_v = $(this).val();
      var curtolower = current_v.toLowerCase();
      if (curtolower.indexOf(name_color2) > -1) {
       $('.swatch_opt_2').find('#custom_2').val(current_v).trigger('change');
      }
    });
  });
// custom 12-14-16
$('.classic-t-shirt-blanket .product_form .swatch_options .swatch_opt_1 .option_label span').click(function(){
    var Sdvalue2= $(this).attr('data-vlutc');
    $(".swatch_opt_1 #custom_1 option").each(function(index,value) {
var current_ve = $(this).val();
      if (current_ve.indexOf(Sdvalue2) > -1) {
       $('#custom_1').val(current_ve).trigger('change');
      }
    });
  });




  
  // tshirt pillow


  $('.t-shirt-Pillow .product_form .swatch_options .swatch_opt_0 .option_label li').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var Tcdvaluep2= $(this).attr('data-vlutc');
    $(".t-shirt-Pillow .swatch_options #custom_0 option").each(function(index,value) {
var Tcurrent_vept = $(this).val();
      if (Tcurrent_vept.indexOf(Tcdvaluep2) > -1) {
       $('.t-shirt-Pillow #custom_0').val(Tcurrent_vept).trigger('change');
      }
    });
  });
$('.t-shirt-Pillow .product_form .swatch_options .swatch_opt_1 .option_label li').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var Tcdvaluep2= $(this).text();
    $(".t-shirt-Pillow .swatch_options #custom_1 option").each(function(index,value) {
var Tcurrent_vept = $(this).val();
      if (Tcurrent_vept.indexOf(Tcdvaluep2) > -1) {
       $('.t-shirt-Pillow #custom_1').val(Tcurrent_vept).trigger('change');
      }
    });
  });
// tshirt curtain
  
$('.t-shirt-Curtains .product_form .swatch_options .swatch_opt_0 .option_label span').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var Tcdvalue2= $(this).attr('data-vlutc');//alert(Tcdvalue2);
    $(".t-shirt-Curtains .swatch_options #custom_0 option").each(function(index,value) {
var Tcurrent_ve = $(this).val();
      if (Tcurrent_ve.indexOf(Tcdvalue2) > -1) {
       $('.t-shirt-Curtains #custom_0').val(Tcurrent_ve).trigger('change');
      }
    });
  });
 // color

   $('.t-shirt-Curtains .product_form .swatch_options .swatch_opt_1 .option_label .swatch_group').click(function(){
     $(this).addClass("active");
  $(this).siblings("").removeClass("active");
     
    var Cname_color= $(this).find('.name_color').html();
    var Cname_color2 = Cname_color.toLowerCase();
    $( ".t-shirt-Curtains .swatch_opt_1 #custom_1 option").each(function(index,value) {
var Ccurrent_v = $(this).val();
      var Ccurtolower = Ccurrent_v.toLowerCase();
      if (Ccurtolower.indexOf(Cname_color2) > -1) {
       $('.t-shirt-Curtains .swatch_opt_1').find('#custom_1').val(Ccurrent_v).trigger('change');
      }
    });
  }); 

//  double side classic

  
$('.double-sided-classic-t-shirt-blanket .product_form .swatch_options .swatch_opt_0 .span_lable_as li').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
  
    var ddvalueL= $(this).find('.big').text();
  if(ddvalueL=='Throw' || ddvalueL=='Twin'){
  var ddvalue2 = ddvalueL.toLowerCase();
  }else{
    var ddvalue2 = ddvalueL;
  }
    $( ".double-sided-classic-t-shirt-blanket .swatch_options #custom_0 option").each(function(index,value) {
     var dcurrent_ve = $(this).val();
      if (dcurrent_ve.indexOf(ddvalue2) > -1) {
       $('.double-sided-classic-t-shirt-blanket #custom_0').val(dcurrent_ve).trigger('change');
      }
    });
  });

$('.double-sided-classic-t-shirt-blanket .product_form .swatch_options .swatch_opt_1 .option_label span').click(function(){
   $(this).addClass("active");
  $(this).siblings("").removeClass("active");
  
    var ddvalue2= $(this).attr('data-vlutc');
    $( ".double-sided-classic-t-shirt-blanket .swatch_options .swatch_opt_1 #custom_1 option").each(function(index,value) {
var ddcurrent_ve = $(this).val();
      if (ddcurrent_ve.indexOf(ddvalue2) > -1) {
       $('.double-sided-classic-t-shirt-blanket #custom_1').val(ddcurrent_ve).trigger('change');
      }
    });
  });

// double side baby blanket

  
  $('.double-sided-baby-blanket .product_form .swatch_options .swatch_opt_0 .span_lable_as li').click(function(){
    $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var dsdvalue2= $(this).find('.big').text();
    $( ".double-sided-baby-blanket .swatch_options #custom_0 option").each(function(index,value) {
var dscurrent_ve = $(this).val();
      if (dscurrent_ve.indexOf(dsdvalue2) > -1)  {
       $('.double-sided-baby-blanket #custom_0').val(dscurrent_ve).trigger('change');
      }
    });
  });

//  custom tempalte
$('.custom_product .product_form .swatch_options .swatch_opt_0 .span_lable_as li').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var CdvalueL= $(this).find('.big').text();
    $( ".custom_product .swatch_options #custom_0 option").each(function(index,value) {
     var Ccurrent_ve = $(this).val();
      if (Ccurrent_ve.indexOf(CdvalueL) > -1) {
       $('.custom_product #custom_0').val(Ccurrent_ve).trigger('change');
      }
    });
  });

// color

  $('.custom_product .product_form .swatch_options .swatch_opt_1 .option_label .swatch_group').click(function(){
    $(this).addClass("active");
  $(this).siblings("").removeClass("active");
    
    var CCname_color= $(this).find('.name_color').html();
    var CCname_color2 = CCname_color.toLowerCase();
    $( ".custom_product .swatch_opt_1 #custom_1 option").each(function(index,value) {
var Ccurrent_C = $(this).val();
      var Ccurtolower = Ccurrent_C.toLowerCase();
      if (Ccurtolower.indexOf(CCname_color2) > -1) {
       $('.custom_product .swatch_opt_1').find('#custom_1').val(Ccurrent_C).trigger('change');
      }
    });
  }); 

$('.custom_product .product_form .swatch_options .swatch_opt_2 .option_label .swatch_group').click(function(){
  $(this).addClass("active");
  $(this).siblings("").removeClass("active");
  
    var CCname_color2= $(this).find('.name_color').html();
    var CCname_color_2 = CCname_color2.toLowerCase();
    $( ".custom_product .swatch_opt_2 #custom_2 option").each(function(index,value) {
var Ccurrent_C2 = $(this).val();
      var Ccurtolower2 = Ccurrent_C2.toLowerCase();
      if (Ccurtolower2.indexOf(CCname_color_2) > -1) {
       $('.custom_product .swatch_opt_2').find('#custom_2').val(Ccurrent_C2).trigger('change');
      }
    });
  }); 

// Colossal

$('.Colossal-tshirt-blanket .product_form .swatch_options .swatch_opt_0 .span_lable_as li').click(function(){
  $(this).addClass('active');
    $(this).siblings("").removeClass("active");
    var Tdvalue_colos= $(this).find('.big').text();
    $( ".Colossal-tshirt-blanket .swatch_options #custom_0 option").each(function(index,value) {
var Colosol = $(this).val();
      
      if(Tdvalue_colos=='Twin'){
        $('.Colossal-tshirt-blanket #custom_0').val('Colossal Twin 4 x 6 layout (requires 19" of fabric - finished size 70" x 104") with 18" panels').trigger('change');
      }else{
        if (Colosol.indexOf(Tdvalue_colos) > -1) {
       $('.Colossal-tshirt-blanket #custom_0').val(Colosol).trigger('change');
      }
      }
    });
  });

  $('.Colossal-tshirt-blanket .product_form .swatch_options .swatch_opt_1 .option_label .swatch_group').click(function(){
    $(this).addClass("active");
  $(this).siblings("").removeClass("active");
    
    var Colocolor2= $(this).find('.name_color').html();
    var Colo_color_2 = Colocolor2.toLowerCase();
    $( ".Colossal-tshirt-blanket .swatch_opt_1 #custom_1 option").each(function(index,value) {
var Colo_t_C2 = $(this).val();
      var Ccurtolower2 = Colo_t_C2.toLowerCase();
      if (Ccurtolower2.indexOf(Colo_color_2) > -1) {
       $('.Colossal-tshirt-blanket .swatch_opt_1').find('#custom_1').val(Colo_t_C2).trigger('change');
      }
    });
  }); 

// baby blanket


  $('.baby-blanket .product_form .swatch_options .swatch_opt_0 .span_lable_as li').click(function(){
     $(this).addClass("active");
  $(this).siblings("").removeClass("active");
    
    var Bdvalue_colos= $(this).find('.big').text();
    $( ".baby-blanket .swatch_options #custom_0 option").each(function(index,value) {
     var Bolosol = $(this).val();
      if (Bolosol.indexOf(Bdvalue_colos) > -1) {
       $('.baby-blanket #custom_0').val(Bolosol).trigger('change');
      }
    });
  });

$('.baby-blanket .product_form .swatch_options .swatch_opt_1 .option_label .swatch_group').click(function(){
  $(this).addClass("active");
  $(this).siblings("").removeClass("active");
  
    var BBlocolor2= $(this).find('.name_color').html();
    var BB_color_2 = BBlocolor2.toLowerCase();
    $( ".baby-blanket .swatch_opt_1 #custom_1 option").each(function(index,value) {
var BB_t_C2 = $(this).val();
      var BBurtolower2 = BB_t_C2.toLowerCase();
      if (BBurtolower2.indexOf(BB_color_2) > -1) {
       $('.baby-blanket .swatch_opt_1').find('#custom_1').val(BB_t_C2).trigger('change');
      }
    });
  }); 





  
  
});

